import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface SupplierSelectionRowContainerProps {
    $disabled?: boolean;
    $hasMultipleContracts?: boolean;
    $selected?: boolean;
}

export const SupplierSelectionRowContainer = styled.div<SupplierSelectionRowContainerProps>`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.space[16]};
    min-height: 56px;
    padding: ${theme.space[8]};
    border-radius: 14px;
    border: 1px solid ${(props) => (props.$selected ? theme.colors.accent.border : theme.colors.border.muted)};
    background-color: ${(props) =>
        props.$selected ? theme.colors.accent.background : theme.colors.background.default};
    box-shadow: ${(props) => (props.$selected && props.$hasMultipleContracts ? theme.shadows.medium : 'none')};
    cursor: ${(props) => (props.$disabled ? 'default' : 'pointer')};
    opacity: ${(props) => (props.$disabled ? 0.3 : 1)};
    transition:
        background-color 100ms ease-out,
        border-color 100ms ease-out,
        box-shadow 100ms ease-out,
        opacity 100ms ease-out,
        transform 160ms ease-out;
    transform: scale(1);
    user-select: none;

    &:hover {
        background-color: ${(props) =>
            props.$selected ? theme.colors.accent.background : theme.colors.background.subtle};
        box-shadow: ${(props) => (props.$disabled ? 'none' : theme.shadows.medium)};
    }
`;
